import { Flex, Typography, List } from '@banhala/ui-kit';
import React from 'react';
import type { RelatedKeyword } from 'shared/src/api/searchService/types';

type Props = {
  keywords: RelatedKeyword[];
  onPress: (keyword: RelatedKeyword, index: number) => void;
};

export const RelatedKeywordList: React.FC<Props> = ({ keywords, onPress }) => {
  if (keywords.length === 0) {
    return null;
  }

  return (
    <Flex height={36}>
      <List
        horizontal
        data={keywords}
        keyExtractor={(item, index) => `${item.raw_keyword}-${index}`}
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={{
          paddingHorizontal: 16,
          paddingVertical: 4,
        }}
        renderItem={({ item, index }) => (
          <Flex
            height={28}
            margin={{ right: 8 }}
            padding={{ horizontal: 10 }}
            borderRadius={14}
            backgroundColor="bg_disabled_primary"
            justifyContent="center"
            onPress={() => onPress(item, index)}
          >
            <Typography type="subtitle3" color="content_secondary">
              {item.display_keyword}
            </Typography>
          </Flex>
        )}
      />
    </Flex>
  );
};